export function isNumericKey(key) {
  // don't want to break this logic while introducing the rule - please fix if touching this code
  // eslint-disable-next-line eqeqeq
  return (key >= 48 && key <= 57) || key == 229 || key == 8;
}

export function isEnterKeyEvent(event) {
  const key = event.which;
  return key === 13;
}
